// import fetchStream from 'fetch-readablestream';
import axios from 'axios';
import {find} from 'lodash';
import {handleApiError} from './apiErrorHandler';
import {XCSRF_TOKEN_HEADER} from 'const';
import Token from './Token';
import {safeFetch} from './safeFetch';

// import {binArrayToJson} from './helpers';

// use credentials in each axios request
axios.defaults.withCredentials = true;
axios.interceptors.request.use((config) => {
   console.debug('req intercept', config);
   config.headers[XCSRF_TOKEN_HEADER] = Token.getCsrfToken();
   return config;
});

export const API_DOMAIN =
   process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_DOMAIN : '';
// export const API_REPORTS_DOMAIN = process.env.REACT_APP_API_DOMAIN;

// function readAllChunks(readableStream: any) {
//    const reader = readableStream.getReader();
//    const chunks = [] as any;

//    function pump() {
//       return reader.read().then(({value, done}: any) => {
//          if (done) {
//             return chunks;
//          }
//          chunks.push(value);
//          return pump();
//       });
//    }

//    return pump();
// }

export default {
   getSecureJson: (url: string) => {
      const fake = find(getMocks, ['url', url]);
      console.debug(fake);
      if (fake) {
         const respData = fake.response();
         // const resp = new Response(JSON.stringify(respData));
         const resp = {
            bodyUsed: true,
            body: respData,
            json: () => Promise.resolve(respData),
            status: 200,
            statusText: '',
         } as Response;
         console.debug('Fake get response', respData);
         return Promise.resolve(resp);
      }

      return safeFetch(url, {
         method: 'GET',
         credentials: 'include',
         headers: {
            'content-type': 'application/json',
            'Cache-Control': 'no-cache',
            // 'Authorization': `Bearer ${getAccessToken()}`
         },
      }).then(handleApiError);
   },

   // getChunkedJson: (url: string) =>
   //    fetchStream(url, {
   //       method: 'GET',
   //       credentials: 'include',
   //       headers: {
   //          'content-type': 'application/json',
   //          // 'Authorization': `Bearer ${getAccessToken()}`
   //       },
   //    })
   //       .then(handleError)
   //       .then((response: Response) => {
   //          return readAllChunks(response.body).then((body: any) => ({
   //             ...response,
   //             fullBody: binArrayToJson(body[0]),
   //          }));
   //       })
   //       .then((res: any) => {
   //          // console.dir(res);
   //          const obj = res.fullBody;
   //          return {
   //             ...res,
   //             json: async () => obj,
   //          };
   //       }),
   get: (url: string, headers?: {[k: string]: string}) =>
      fetch(url, {
         method: 'GET',
         // credentials: 'same-origin',
         credentials: 'include',
         headers: {
            // 'Authorization': `Bearer ${getAccessToken()}`
            ...headers,
         },
      }).then(handleApiError),
   getSecure: (url: string, headers?: {[k: string]: string}) =>
      safeFetch(url, {
         method: 'GET',
         // credentials: 'same-origin',
         credentials: 'include',
         headers: {
            // 'Authorization': `Bearer ${getAccessToken()}`
            ...headers,
         },
      }).then(handleApiError),

   postSecureJson: async (url: string, body: BodyInit | null, options?: {headers: HeadersInit}) => {
      const fake = find(postMocks, ['url', url]);
      console.debug(fake);

      if (fake) {
         try {
            const respData = await fake.response(body);
            // const resp = new Response(JSON.stringify(respData));
            const resp = {
               bodyUsed: true,
               body: respData,
               json: () => Promise.resolve(respData),
               status: 200,
               statusText: '',
            } as Response;
            console.debug('Fake post response', respData, body);
            return resp; //Promise.resolve(resp);
         } catch (er) {
            const e = er as {status: number; data: any; statusText: string};
            const resp = {
               bodyUsed: true,
               body: e.data,
               json: () => Promise.resolve(e.data),
               status: e.status,
               statusText: e.statusText,
            } as Response;
            throw resp;
         }
      }

      const resp = await safeFetch(url, {
         body,
         method: 'POST',
         credentials: 'include',
         headers: options?.headers ?? {
            'content-type': 'application/json',
            [XCSRF_TOKEN_HEADER]: Token.getCsrfToken(),
            // 'Authorization': `Bearer ${getAccessToken()}`
         },
      });
      // console.debug('Post resp', resp);

      return handleApiError(resp);
   },

   putSecureJson: (url: string, body: BodyInit) =>
      safeFetch(url, {
         body,
         method: 'PUT',
         credentials: 'include',
         headers: {
            'content-type': 'application/json',
            [XCSRF_TOKEN_HEADER]: Token.getCsrfToken(),
            // 'Authorization': `Bearer ${getAccessToken()}`
         },
      }).then(handleApiError),

   deleteSecureJson: (url: string, body?: BodyInit) =>
      safeFetch(url, {
         body,
         method: 'DELETE',
         credentials: 'include',
         headers: {
            'content-type': 'application/json',
            [XCSRF_TOKEN_HEADER]: Token.getCsrfToken(),
            // 'Authorization': `Bearer ${getAccessToken()}`
         },
      }).then(handleApiError),
};

type ResponseCB = (body?: BodyInit | null) => any;
const postMocks = [] as {url: string; response: any}[];
const getMocks = [] as {url: string; response: any}[];

export const injectPost = (url: string, response: ResponseCB) => {
   postMocks.push({
      url,
      response,
   });
};

export const injectGet = (url: string, response: ResponseCB) => {
   getMocks.push({
      url,
      response,
   });
};
